import AlphabetNextService from 'app_services/letters/alphabetNextService'
import { store } from 'app_storage/redux-storage'
import parse from 'html-react-parser'
import React, { CSSProperties, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Store } from 'redux'

// import NextQuestionButtonComponent from '../../../../commons/nextQuestionButton/containers/nextQuestionButtonComponent'
import '../questionMultipleChoiceUniqueAnswer.scss'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';

//@Import actions
// import { updateQuestionState } from 'app_events/resource/exercise/actions'
//@end

interface IQuestionMultipleChoiceUniqueAnswerLayoutProps {
  questionData: any
  defaultAnswer: string | null
  className?: string
  style?: CSSProperties
  hideButtons?: boolean
  disabled?: boolean
  showCorrect?: boolean
  showMyResponse?: boolean
  validateMyResponse?: boolean
  showFeedback?: boolean
  onNextQuestion: (asnwerData: any) => void
  handleSendOnChange: (text: string) => any
}

const QuestionMultipleChoiceUniqueAnswerLayout: React.FC<IQuestionMultipleChoiceUniqueAnswerLayoutProps> = (props) => {
  const alphabetNextService: AlphabetNextService = new AlphabetNextService('ABCDEFGHIJKLMNOPQRSTUVWXYZ')
  const storeObject: Store = store
  const [radioStatus, setRadioStatus] = useState<string>(props.defaultAnswer ? props.defaultAnswer : '')
  const { t } = useTranslation()
  const form = useForm()

  useEffect(() => {
    if (props.defaultAnswer) {
      setRadioStatus(props.defaultAnswer)
    }
  }, [props.defaultAnswer])

  useEffect(() => {
    // storeObject.dispatch(updateQuestionState({
    //   questionData: props.questionData,
    //   answer: radioStatus,
    //   type: 'multipleChoiceUniqueAnswer',
    // }))
    // @INFO Enviar el onChange
    props.handleSendOnChange(radioStatus)
  }, [radioStatus, props.questionData._id])

  useEffect(() => {
    return () => {
      // storeObject.dispatch(updateQuestionState({}))
    }
  }, [])

  return (
    <div
      className={`question_multiple_choice_unique_answer-component ${props.className}`}
      style={props.style}
    >
      {/* <div className='content'>{parse(props.questionData.content)}</div> */}
      <div className='answers-container form-check'>
        <form onSubmit={form.handleSubmit((data) => props.onNextQuestion(data))}>
          {props.questionData.answers.length > 0 &&
            props.questionData.answers.map((answer: any) => {
              if (answer.unique.toString() === radioStatus) {
                return (
                  <div
                    className={`answer ${props.showMyResponse ? 'my-answer' : ''} ${props.validateMyResponse ? (answer?.is_correct ? 'correct' : 'incorrect') : ''} ${props.showCorrect && answer?.is_correct ? 'correct' : '' }`}
                    key={answer._id}
                  >
                    <input
                      ref={form.register({ required: false })}
                      className='form-check-input'
                      type='radio'
                      defaultChecked={true}
                      value={answer.unique}
                      name='answer'
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        console.log('EVENTO', e.currentTarget.value)
                        setRadioStatus(e.currentTarget.value)
                      }}
                      disabled={props.disabled}
                      id={answer._id}
                      key={answer._id}
                    />
                    <label
                      htmlFor={answer._id}
                      className='content-answer'
                    >
                      <div className='radio'>
                        <div className='radio-fill'></div>
                      </div>
                      <p>{alphabetNextService.next()}.&nbsp;</p>
                      {parse(answer.content)}
                      {props.showCorrect || props.validateMyResponse ?
                      <p
                        className="text-status-response"
                      >
                        {props.showCorrect || props.validateMyResponse || props.showMyResponse ?
                          props.showMyResponse ?
                            'Tu respuesta'
                          :
                          answer?.is_correct ?
                            'Respuesta correcta':
                            'Respuesta incorrecta'
                        :''}
                      </p>:null}
                    </label>
                    {props.showFeedback && answer.feedback ?
                    <div className="container-feedback">
                        <LabelComponent
                          style={{fontWeight: 700}}
                        >
                          Justificación:
                        </LabelComponent>
                        {parse(answer.feedback)}
                    </div>:null}
                  </div>
                )
              } else {
                return (
                  <div
                    className={`answer ${props.showCorrect && answer?.is_correct ? 'correct' : '' }`}
                    key={answer._id}
                  >
                    <input
                      ref={form.register({ required: false })}
                      className='form-check-input'
                      type='radio'
                      value={answer.unique}
                      name='answer'
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setRadioStatus(e.currentTarget.value)
                      }}
                      disabled={props.disabled}
                      id={answer._id}
                      key={answer._id}
                    />
                    <label
                      htmlFor={answer._id}
                      className='content-answer'
                    >
                      <div className='radio'>
                        <div className='radio-fill'></div>
                      </div>
                      <p>{alphabetNextService.next()}.&nbsp;</p>
                      {parse(answer.content)}
                      {props.showCorrect ?
                      <p
                        className="text-status-response"
                      >
                        {answer?.is_correct ?
                          'Respuesta correcta':
                          'Respuesta incorrecta'
                        }
                      </p>:null}
                    </label>
                  </div>
                )
              }
            })}
            {/* {!props.hideButtons ?
              <NextQuestionButtonComponent />
            :null} */}
        </form>
      </div>
    </div>
  )
}

export default QuestionMultipleChoiceUniqueAnswerLayout
